"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const tooltip_styles_1 = require("./tooltip-styles");
const tooltip_hook_1 = require("./tooltip-hook");
function Tooltip({ children, title, placement, type = 'HOVER', ...childrenProps }) {
    const classes = tooltip_styles_1.useStyles();
    const { opened, openTooltip, closeTooltip, wrappedChildren } = tooltip_hook_1.useTooltip(type, children, childrenProps);
    if (type === 'HOVER') {
        return (react_1.default.createElement(Tooltip_1.default, { PopperProps: {
                disablePortal: false,
            }, interactive: true, title: title !== undefined ? (react_1.default.createElement(Typography_1.default, { component: "div" }, title)) : (''), classes: classes, placement: placement }, wrappedChildren));
    }
    else {
        return (react_1.default.createElement(Tooltip_1.default, { PopperProps: {
                disablePortal: false,
            }, interactive: true, title: title !== undefined ? (react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: closeTooltip },
                react_1.default.createElement(Typography_1.default, { component: "div" }, title))) : (''), classes: classes, placement: placement, open: opened, onClick: title !== undefined ? openTooltip : undefined }, wrappedChildren));
    }
}
exports.Tooltip = Tooltip;
//# sourceMappingURL=tooltip.js.map